import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "20",
            height: "20",
            x: "2",
            y: "2",
            rx: "2.18",
            ry: "2.18",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Line, { x1: "7", x2: "7", y1: "2", y2: "22", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "17", x2: "17", y1: "2", y2: "22", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "22", y1: "12", y2: "12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "7", y1: "7", y2: "7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "7", y1: "17", y2: "17", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "17", x2: "22", y1: "17", y2: "17", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "17", x2: "22", y1: "7", y2: "7", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Film";
const Film = memo(themed(Icon));
export {
  Film
};
//# sourceMappingURL=film.js.map
